<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
  >
    <rect x="4" y="4" width="48" height="48" rx="24" fill="#AFDEDC" />
    <rect
      x="4"
      y="4"
      width="48"
      height="48"
      rx="24"
      stroke="#D2EBE9"
      stroke-width="8"
    />
    <path
      d="M28 30V26.5M28 23H28.01M25.9 35.2L27.36 37.1467C27.5771 37.4362 27.6857 37.5809 27.8188 37.6327C27.9353 37.678 28.0647 37.678 28.1812 37.6327C28.3143 37.5809 28.4229 37.4362 28.64 37.1467L30.1 35.2C30.3931 34.8091 30.5397 34.6137 30.7185 34.4645C30.9569 34.2656 31.2383 34.1248 31.5405 34.0535C31.7671 34 32.0114 34 32.5 34C33.8978 34 34.5967 34 35.1481 33.7716C35.8831 33.4672 36.4672 32.8831 36.7716 32.1481C37 31.5967 37 30.8978 37 29.5V23.8C37 22.1198 37 21.2798 36.673 20.638C36.3854 20.0735 35.9265 19.6146 35.362 19.327C34.7202 19 33.8802 19 32.2 19H23.8C22.1198 19 21.2798 19 20.638 19.327C20.0735 19.6146 19.6146 20.0735 19.327 20.638C19 21.2798 19 22.1198 19 23.8V29.5C19 30.8978 19 31.5967 19.2284 32.1481C19.5328 32.8831 20.1169 33.4672 20.8519 33.7716C21.4033 34 22.1022 34 23.5 34C23.9886 34 24.2329 34 24.4595 34.0535C24.7617 34.1248 25.0431 34.2656 25.2815 34.4645C25.4603 34.6137 25.6069 34.8091 25.9 35.2Z"
      stroke="#174645"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
